module.exports = __webpack_public_path__ + "static/media/net.6b5d01c5.png";